module.exports = __webpack_public_path__ + "static/media/seitenwind.a1cb5992.svg";